import { put, select } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import services from '@services'
import { ApplicationState } from '@store/types'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { hideLoading } from '@store/refinanciamento/documentos/actions'
import { BridgeService } from '@services/bridge'
import { StepRefin } from '@utils/enums'

import { dadosPropostaError, dadosPropostaRequest, dadosPropostaSucess } from '../actions'
import { DadosPropostaPayload, PropostaApi } from '../types'

interface Props {
  actionCallbackError: {
    message: string
    actionCallback: () => AnyAction
    actionTitle: string
    code?: string
  }
  type: string
  action?: AnyAction
}

export default function* dadosPropostaSaga({
  actionCallbackError = {
    message: 'Aguarde um instante e tente novamente.',
    actionCallback: () => dadosPropostaRequest(),
    actionTitle: 'Tentar Novamente',
    code: StepRefin.ERRO_BUSCAR_PROPOSTA,
  },
  action,
}: Props) {
  const appState = yield* select((state: ApplicationState) => state)
  const payload = action?.payload as DadosPropostaPayload
  const propostaAntiga = appState.refinanciamento.contratos.contratosSelecionados.map(
    (item) => item.numeroProposta,
  )[0]
  let data: PropostaApi
  let status: number | undefined
  try {
    if (BridgeService.isBrowser()) {
      const { data: dataResponse, status: statusResponse } = yield services.getDadosPropostaService(
        appState.session.accessToken,
      )
      data = dataResponse
      status = statusResponse
    } else {
      const { data: dataResponse, status: statusResponse } =
        yield services.postDadosPropostaService(
          {
            numeroProposta:
              String(appState.refinanciamento.proposta.numeroProposta) || propostaAntiga,
            cpf: appState.refinanciamento.dadosPessoais.cpfDadosPessoais ?? '',
            email: appState.refinanciamento.contato.email,
            telefone: appState.refinanciamento.contato.telefone,
          },
          appState.session.accessToken,
        )
      data = dataResponse
      status = statusResponse
    }

    yield put(
      setLastServiceResponse({
        code: String(status ?? 'OK'),
        serviceName: BridgeService.isBrowser()
          ? 'getDadosPropostaService'
          : 'postDadosPropostaService',
      }),
    )
    yield put(dadosPropostaSucess(data))
    yield put(hideLoading())
    if (payload && status === 200 && data) payload.callback()
    if (data && status === 200) return true
    yield put(showError(actionCallbackError))
    return false
  } catch (error) {
    yield put(
      setLastServiceResponse({
        code: 'ERROR',
        serviceName: BridgeService.isBrowser()
          ? 'getDadosPropostaService'
          : 'postDadosPropostaService',
      }),
    )
    yield put(showError(actionCallbackError))
    yield put(hideLoading())
    yield put(dadosPropostaError())
    return false
  }
}
